(() => {
  if (window.__ldPriceSliderLive) return;
  window.__ldPriceSliderLive = true;

  const PRICE_MIN = 'filter.v.price.gte';
  const PRICE_MAX = 'filter.v.price.lte';

  const parser = new DOMParser();

  function collectionUrlWithoutPrice() {
    const url = new URL(window.location.href);
    url.searchParams.delete(PRICE_MIN);
    url.searchParams.delete(PRICE_MAX);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    // Preserve preview_theme_id so price filtering stays inside the current theme preview.
    return url;
  }

  function collectPrices(doc, mins, maxs) {
    doc.querySelectorAll(
      '#product-grid .grid__item[data-product-price-min]'
    ).forEach((item) => {
      // Collection cards are presented as "From" prices, so the customer-facing
      // slider must use each product's starting price rather than the highest
      // metal/variant price.
      const startingPrice = Number(item.dataset.productPriceMin);
      if (Number.isFinite(startingPrice) && startingPrice > 0) {
        mins.push(startingPrice);
        maxs.push(startingPrice);
      }
    });
  }

  function totalPages(doc) {
    let total = 1;
    doc.querySelectorAll('.pagination a[href*="page="]').forEach((link) => {
      try {
        const page = Number(
          new URL(link.getAttribute('href') || link.href, window.location.origin)
            .searchParams.get('page')
        );
        if (Number.isFinite(page)) total = Math.max(total, page);
      } catch (_) {}
    });
    return total;
  }

  async function getAvailableRange() {
    const base = collectionUrlWithoutPrice();
    const firstHtml = await fetch(base.toString(), { credentials: 'same-origin' })
      .then((response) => response.text());
    const firstDoc = parser.parseFromString(firstHtml, 'text/html');

    const mins = [];
    const maxs = [];
    collectPrices(firstDoc, mins, maxs);

    const pages = totalPages(firstDoc);
    if (pages > 1) {
      const requests = [];
      for (let page = 2; page <= pages; page += 1) {
        const pageUrl = new URL(base.href);
        pageUrl.searchParams.set('page', String(page));
        requests.push(
          fetch(pageUrl.toString(), { credentials: 'same-origin' })
            .then((response) => response.text())
            .then((html) => parser.parseFromString(html, 'text/html'))
        );
      }

      const docs = await Promise.all(requests);
      docs.forEach((doc) => collectPrices(doc, mins, maxs));
    }

    if (!mins.length || !maxs.length) return null;

    const min = Math.min(...mins);
    const max = Math.max(...maxs);

    if (!Number.isFinite(min) || !Number.isFinite(max) || max < min) return null;
    return { min, max };
  }

  function activePrice(range) {
    const params = new URLSearchParams(window.location.search);

    const rawMin = params.get(PRICE_MIN);
    const rawMax = params.get(PRICE_MAX);

    let min = rawMin !== null && rawMin !== '' ? Number(rawMin) : range.min;
    let max = rawMax !== null && rawMax !== '' ? Number(rawMax) : range.max;

    if (!Number.isFinite(min)) min = range.min;
    if (!Number.isFinite(max)) max = range.max;

    min = Math.max(range.min, Math.min(min, range.max));
    max = Math.max(min, Math.min(max, range.max));

    return { min, max };
  }

  function moneyText(value) {
    var currencyNode = document.querySelector('#FacetFiltersForm .field-currency') || document.querySelector('#FacetFiltersFormMobile .field-currency');
    var symbol = currencyNode ? currencyNode.textContent.trim() : '$';
    var amount = Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return symbol + amount;
  }

  function syncActivePriceLabel(selected) {
    document.querySelectorAll('[data-ld-price-active]').forEach(function (node) {
      var minNode = node.querySelector('[data-ld-price-active-min]');
      var maxNode = node.querySelector('[data-ld-price-active-max]');
      if (minNode) minNode.textContent = moneyText(selected.min);
      if (maxNode) maxNode.textContent = moneyText(selected.max);
    });
  }

  function normalizeStalePriceParams(range) {
    const url = new URL(window.location.href);
    const rawMin = url.searchParams.get(PRICE_MIN);
    const rawMax = url.searchParams.get(PRICE_MAX);

    let changed = false;

    if (rawMin !== null) {
      const min = Number(rawMin);
      if (!Number.isFinite(min) || min <= range.min) {
        url.searchParams.delete(PRICE_MIN);
        changed = true;
      } else if (min > range.max) {
        url.searchParams.set(PRICE_MIN, String(Math.round(range.min)));
        changed = true;
      }
    }

    if (rawMax !== null) {
      const max = Number(rawMax);
      if (!Number.isFinite(max) || max >= range.max) {
        url.searchParams.delete(PRICE_MAX);
        changed = true;
      } else if (max < range.min) {
        url.searchParams.set(PRICE_MAX, String(Math.round(range.max)));
        changed = true;
      }
    }

    if (!changed) return false;

    url.searchParams.delete('page');
    url.searchParams.delete('section_id');

    const query = url.searchParams.toString();
    window.location.replace(url.pathname + (query ? '?' + query : ''));
    return true;
  }

  function applyPrice(min, max, available) {
    const url = new URL(window.location.href);

    url.searchParams.delete('page');
    url.searchParams.delete('section_id');

    if (min <= available.min) url.searchParams.delete(PRICE_MIN);
    else url.searchParams.set(PRICE_MIN, String(Math.round(min)));

    if (max >= available.max) url.searchParams.delete(PRICE_MAX);
    else url.searchParams.set(PRICE_MAX, String(Math.round(max)));

    window.location.assign(url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : ''));
  }

  function configurePriceRange(priceRange, available, selected) {
    const slider = priceRange.querySelector('.price-slider-range');
    const inputs = priceRange.querySelectorAll(
      'input[name="' + PRICE_MIN + '"], input[name="' + PRICE_MAX + '"]'
    );
    if (!slider || inputs.length < 2 || typeof noUiSlider === 'undefined') return;

    const minInput = Array.from(inputs).find((input) => input.name === PRICE_MIN);
    const maxInput = Array.from(inputs).find((input) => input.name === PRICE_MAX);
    if (!minInput || !maxInput) return;

    slider.dataset.min = String(available.min);
    slider.dataset.max = String(available.max);
    slider.dataset.minValue = String(selected.min);
    slider.dataset.maxValue = String(selected.max);

    minInput.value = String(Math.round(selected.min));
    maxInput.value = String(Math.round(selected.max));
    minInput.dataset.min = String(available.min);
    minInput.dataset.max = String(available.max);
    maxInput.dataset.min = String(available.min);
    maxInput.dataset.max = String(available.max);

    if (slider.noUiSlider) {
      try { slider.noUiSlider.destroy(); } catch (_) {}
    }

    // One matching product (or several with the same starting price):
    // show the exact price instead of falling back to Shopify's broad range.
    if (available.max === available.min) {
      slider.classList.add('is-single-price');
      slider.innerHTML = '';
      slider.style.pointerEvents = 'none';
      slider.setAttribute('aria-disabled', 'true');
      minInput.value = String(Math.round(available.min));
      maxInput.value = String(Math.round(available.max));
      minInput.readOnly = true;
      maxInput.readOnly = true;
      return;
    }

    slider.classList.remove('is-single-price');
    slider.style.pointerEvents = '';
    slider.removeAttribute('aria-disabled');
    minInput.readOnly = false;
    maxInput.readOnly = false;

    noUiSlider.create(slider, {
      start: [selected.min, selected.max],
      direction: document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr',
      connect: [false, true, false],
      step: 1,
      range: {
        min: available.min,
        max: available.max
      },
      handleAttributes: [
        { 'aria-label': 'Minimum price' },
        { 'aria-label': 'Maximum price' }
      ]
    });

    slider.noUiSlider.on('update', (values) => {
      minInput.value = String(Math.round(Number(values[0])));
      maxInput.value = String(Math.round(Number(values[1])));
    });

    let timer;
    slider.noUiSlider.on('set', (values) => {
      clearTimeout(timer);
      timer = window.setTimeout(() => {
        const min = Math.round(Number(values[0]));
        const max = Math.round(Number(values[1]));
        applyPrice(min, max, available);
      }, 180);
    });

    const submitTypedPrice = () => {
      let min = Number(minInput.value);
      let max = Number(maxInput.value);

      if (!Number.isFinite(min)) min = available.min;
      if (!Number.isFinite(max)) max = available.max;

      min = Math.max(available.min, Math.min(min, available.max));
      max = Math.max(min, Math.min(max, available.max));

      applyPrice(min, max, available);
    };

    minInput.addEventListener('change', submitTypedPrice);
    maxInput.addEventListener('change', submitTypedPrice);
  }

  async function init() {
    const ranges = document.querySelectorAll(
      '#FacetFiltersForm price-range, #FacetFiltersFormMobile price-range'
    );
    if (!ranges.length) return;

    try {
      const available = await getAvailableRange();
      if (!available) return;

      // Remove/clamp stale price parameters left over from a previous
      // Shape/Style/Setting/Gender result set before drawing the slider.
      if (normalizeStalePriceParams(available)) return;

      const selected = activePrice(available);
      ranges.forEach((priceRange) => configurePriceRange(priceRange, available, selected));
      syncActivePriceLabel(selected);
    } catch (_) {
      // Leave Shopify's existing slider intact if range discovery fails.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
